import { Injectable } from '@angular/core';
import { Animation, NotificationService, Position, Type } from '@progress/kendo-angular-notification';

import { NotificationType } from '../models/types/notification-type.enum';

import notificationSettings from '../../assets/config/notifications-config.json';

@Injectable({ providedIn: 'root' })
export class CustomNotificationService {
    constructor(private notificationService: NotificationService) {}

    private showNotification(
        message: string,
        type: Type = { style: 'error', icon: true },
        hideAfter = 10000,
        position: Position = { horizontal: 'center', vertical: 'top' },
        animation: Animation = { type: 'slide', duration: 500 }
    ): void {
        if (!message) {
            return;
        }
        this.notificationService.show({
            content: message,
            type: type,
            animation: animation,
            position: position,
            hideAfter: hideAfter,
            closable: false
        });
    }

    public notify(message: string, type: NotificationType, hideAfter = 10000): void {
        this.showNotification(message, { style: type, icon: true }, hideAfter);
    }

    public error(message: string): void {
        this.notify(message, NotificationType.ERROR, notificationSettings.error);
    }

    public info(message: string): void {
        this.notify(message, NotificationType.INFO, notificationSettings.info);
    }

    public success(message: string): void {
        this.notify(message, NotificationType.SUCCESS, notificationSettings.success);
    }

    public warn(message: string): void {
        this.notify(message, NotificationType.WARNING, notificationSettings.warning);
    }

    public handleError(errorResponse: any): void {
        if (errorResponse == null) {
            return;
        }
        try {
            console.error(JSON.stringify(errorResponse));
        } catch (exc) {
            console.error(errorResponse);
        }
        let errMsg = errorResponse;
        if (errorResponse.error) {
            errMsg =
                errorResponse.error?.message + ' (' + errorResponse.error?.httpStatusCode + ' - ' + errorResponse.error?.httpStatus + ')';
        } else if (errorResponse.message) {
            errMsg = errorResponse.message;
        }
        this.error(errMsg);
    }
}
